import { TAG } from "@blacknut/javascript-sdk/dist/api/ApiService";
import { logD } from "@blacknut/logging/dist";
import { OnboardingFlow } from "../models/SubscriptionFlow";
import { BillingInfo, isValidSubscription, User } from "../models/User";
import { Route, RouteNames } from "./WithRouter";

export const onUserSignupSuccessV3 = (opts: {
  flow: OnboardingFlow;
  navigate: (route: Route | string) => void;
  user: User;
  billingInfo: BillingInfo;
  allowNoSubscription?: boolean;
  preshippingId?: string;
}) => {
  const {
    flow,
    navigate,
    user,
    billingInfo,
    allowNoSubscription = false,

    preshippingId,
  } = opts;
  logD(TAG, "onUserSignupSuccess");
  if (user.anonymous) {
    navigate({
      name: RouteNames.HOME,
    });
  } else if (
    (isValidSubscription(user, billingInfo) &&
      !billingInfo.subscription?.plan.default) ||
    allowNoSubscription
  ) {
    navigate({
      name: RouteNames.SELECT_PROFILE,
      clearHistory: true,
      fromRegister: true,
    });
  } else {
    if (flow.checkoutScreen) {
      navigate({
        name: RouteNames.PAYMENT_SELECTION,
        preId: preshippingId,
      });
    } else if (flow.checkoutCardScreen) {
      navigate({
        name: RouteNames.PAYMENT_SELECTION_CARD,
        preId: preshippingId,
      });
    } else if (flow.checkoutRedeemScreen) {
      navigate({
        name: RouteNames.PAYMENT_SELECTION_COUPON,
        preId: preshippingId,
      });
    }
  }
};
